var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewBuyout',{attrs:{"isReadonly":true,"title":"Detail výkupu"}})
}
var staticRenderFns = []

export { render, staticRenderFns }